import { nectarApi } from './client'

export type AccessGatePhrase = {
  id: string
  language: string
  text: string
}

export type AccessGateStatus = 'PENDING' | 'PROCESSING' | 'AUTO_FLAGGED' | 'AUTO_PASSED' | 'APPROVED' | 'REJECTED'

export const getRandomAccessGatePhrase = (language: string) =>
  nectarApi.get<AccessGatePhrase>('/v1/access-gate/phrase', { language })

export const getAccessGateStatusForEnrollment = (enrollmentId: string) =>
  nectarApi.get<{ submitted: boolean }>('/v1/access-gate/status', { enrollmentId })

export const submitAccessGateCheck = (formData: FormData) =>
  nectarApi.post<{ id: string; status: AccessGateStatus }>('/v1/access-gate', formData)
